/* Quorix wishlist: saves favorites in the visitor's browser (no account needed). */
(function () {
  'use strict';
  var KEY = 'quorix_wishlist';
  var PAGE = '/pages/wishlist';
  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.6-9.3C1 8 2.9 4.5 6.4 4.5c2.1 0 3.6 1.2 4.4 2.5h2.4c.8-1.3 2.3-2.5 4.4-2.5 3.5 0 5.4 3.5 4 6.7-2.1 4.7-9.6 9.3-9.6 9.3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var list = read();
    var i = list.indexOf(h);
    if (i === -1) { list.unshift(h); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }
  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function money(cents) {
    var fmt = (window.QuorixTheme && window.QuorixTheme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function makeButton(handle, kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wl-btn wl-btn--' + kind;
    b.setAttribute('data-wishlist-toggle', handle);
    b.innerHTML = HEART + (kind === 'product' ? '<span class="wl-btn__label"></span>' : '');
    return b;
  }

  function paintButton(b) {
    var on = has(b.getAttribute('data-wishlist-toggle'));
    if (b.classList.contains('is-active') !== on) b.classList.toggle('is-active', on);
    var pressed = on ? 'true' : 'false';
    if (b.getAttribute('aria-pressed') !== pressed) {
      b.setAttribute('aria-pressed', pressed);
      b.setAttribute('aria-label', on ? 'Remove from favorites' : 'Add to favorites');
    }
    var label = b.querySelector('.wl-btn__label');
    var text = on ? 'Saved to favorites' : 'Add to favorites';
    if (label && label.textContent !== text) label.textContent = text;
  }

  function sync() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = n;
      if (el.getAttribute('data-count') !== String(n)) el.setAttribute('data-count', n);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(paintButton);
  }

  function addCardButtons(root) {
    (root || document).querySelectorAll('article.card-product').forEach(function (card) {
      if (card.querySelector('[data-wishlist-toggle]')) return;
      var link = card.querySelector('a.card-product__link');
      var h = link && handleFromUrl(link.getAttribute('href'));
      if (!h) return;
      card.appendChild(makeButton(h, 'card'));
    });
  }

  function addProductButton() {
    var root = document.querySelector('[data-product-root]');
    if (!root || root.querySelector('[data-wishlist-toggle]')) return;
    var h = handleFromUrl(location.pathname);
    var row = root.querySelector('.buy-row');
    if (!h || !row) return;
    row.insertAdjacentElement('afterend', makeButton(h, 'product'));
  }

  function addHeaderLink() {
    var actions = document.querySelector('.site-header__actions');
    if (!actions || actions.querySelector('.wl-header')) return;
    var a = document.createElement('a');
    a.className = 'header-icon wl-header';
    a.href = PAGE;
    a.setAttribute('aria-label', 'Favorites');
    a.innerHTML = HEART + '<span class="cart-count wl-count" data-wishlist-count data-count="0">0</span>';
    var cart = actions.querySelector('a[href*="/cart"]');
    actions.insertBefore(a, cart || null);
  }

  function renderPage() {
    var mount = document.getElementById('quorix-wishlist');
    if (!mount) return;
    var list = read();
    if (!list.length) {
      mount.innerHTML = '<div class="wl-empty"><p>You have not saved any favorites yet.</p><p>Tap the heart on any product to keep it here.</p><a class="btn" href="/collections/all">Browse products</a></div>';
      return;
    }
    mount.innerHTML = '<p class="wl-loading">Loading your favorites...</p>';
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var alive = items.filter(Boolean);
      var html = alive.map(function (p) {
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        var price = p.price_varies ? 'From ' + money(p.price_min) : money(p.price);
        return '<article class="card-product">' +
          '<a href="' + esc(p.url) + '" class="card-product__link">' +
          '<div class="card-product__media">' + (img ? '<img class="card-product__img" src="' + esc(img) + (img.indexOf('?') === -1 ? '?' : '&') + 'width=720" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
          '<div class="card-product__info"><h3 class="card-product__title">' + esc(p.title) + '</h3>' +
          '<div class="price"><span class="price__current">' + esc(price) + '</span></div>' +
          (p.available ? '' : '<p class="wl-sold">Sold out</p>') + '</div></a></article>';
      }).join('');
      // Drop products that no longer exist from the saved list
      if (alive.length !== list.length) write(alive.map(function (p) { return p.handle; }));
      mount.innerHTML = alive.length ? '<div class="product-grid">' + html + '</div>' : '<div class="wl-empty"><p>Your saved products are no longer available.</p><a class="btn" href="/collections/all">Browse products</a></div>';
      addCardButtons(mount);
      sync();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(b.getAttribute('data-wishlist-toggle'));
    b.classList.remove('wl-pop'); void b.offsetWidth; if (added) b.classList.add('wl-pop');
    if (!added && document.getElementById('quorix-wishlist')) renderPage();
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  function init() {
    addHeaderLink();
    addCardButtons();
    addProductButton();
    renderPage();
    sync();
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function (records) {
        // Only react when new product cards appear, never to our own button updates
        var relevant = records.some(function (r) {
          return Array.prototype.some.call(r.addedNodes, function (n) {
            return n.nodeType === 1 && !(n.matches && n.matches('.wl-btn')) &&
              ((n.matches && n.matches('article.card-product')) || (n.querySelector && n.querySelector('article.card-product')));
          });
        });
        if (!relevant || pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; addCardButtons(); sync(); });
      })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
